'use strict';

var $backdrop = document.querySelector('.tt-backdrop');
var $navBackdrop = document.querySelector('.header-nav-backdrop');

var Backdrop = {
  show: function show(cls) {
    $backdrop && $backdrop.classList.add('is-active');
    $navBackdrop && $navBackdrop.classList.add('is-active');

    if (cls) $backdrop && $backdrop.classList.add(cls);
  },

  hide: function hide(cls) {
    $backdrop && $backdrop.classList.remove('is-active');
    $navBackdrop && $navBackdrop.classList.remove('is-active');

    if (cls) $backdrop && $backdrop.classList.remove(cls);
  }
};

module.exports = Backdrop;
